import { getSortedFields } from '@wix/form-fields';
import { FIELD_PREVIEWS, getFormFieldLabel } from '@wix/form-fields/preview';
import { TRANSLATIONS_NAMESPACE } from './translations';
export const getSubmissionPreview = _ref => {
  let {
    form,
    values,
    i18n,
    includeDeletedFields = false,
    includeEmptyValues = false
  } = _ref;
  const sortedFields = getSortedFields(form);
  const t = i18n.getFixedT(i18n.languages, TRANSLATIONS_NAMESPACE);
  const language = i18n.language;
  const submissionValues = getSubmissionValues({
    values,
    fields: sortedFields,
    t,
    language,
    includeEmptyValues
  });
  if (includeDeletedFields) {
    const deletedFieldsSubmissionValues = getSubmissionValues({
      values,
      fields: form.deletedFields ?? [],
      t,
      language,
      includeEmptyValues
    });
    return [...submissionValues, ...deletedFieldsSubmissionValues];
  }
  return submissionValues;
};
const getSubmissionValues = _ref2 => {
  let {
    values,
    fields,
    t,
    language,
    includeEmptyValues
  } = _ref2;
  if (!fields) {
    return [];
  }
  return fields.reduce((result, field) => {
    var _field$view;
    const target = field.target;
    if (!target) {
      return result;
    }
    const fieldType = (_field$view = field.view) == null ? void 0 : _field$view.fieldType;
    if (!fieldType) {
      return result;
    }
    const getFieldPreview = FIELD_PREVIEWS[fieldType];
    if (!getFieldPreview) {
      return result;
    }
    if (!values.hasOwnProperty(target)) {
      return result;
    }
    const value = values[target];
    const formatted = getFieldPreview({
      field,
      value
    }, t, language);
    const label = getFormFieldLabel(field);
    if (formatted) {
      result.push(formatted);
    } else if (includeEmptyValues && label) {
      result.push({
        label,
        value: null
      });
    }
    return result;
  }, []);
};
//# sourceMappingURL=submission-preview.js.map